import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import PostCard from './PostCard';
import axios from 'axios';
import orn from './../../../assets/images/ornament.svg';

function Qaror(props) {
    let [posts, setPosts] = useState([])
    useEffect(() => {
        axios.get('/siteqaror')
            .then(res => {
                setPosts(res.data)
            })
    }, [])
    return (
        <div>
            <div className="page-intro" style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <h1>Normativ-huquqiy hujjatlar</h1>
            </div>
            <Row className='mt-4' style={{ gap: '20px' }}>
                {
                    posts.map(p => (
                        <Col key={p.id} md={3}>
                            <PostCard post={p} />
                        </Col>

                    ))
                }
            </Row>

        </div>
    );
}

export default Qaror;